import { useContext } from 'react';
import { RBACPermissionsContext } from '../../components/layout/rbac-permissions-context';

export const useRBACPermissionsContext = () => {
  const context = useContext(RBACPermissionsContext);
  if (!context) {
    throw new Error('useRBACPermissionsContext must be used within RBACPermissionsProvider');
  }
  return context;
};